import React from "react";
import { Badge } from "../ui/badge";

const VARIANT_BADGE = {
  variant_mismatch: { label: "Beda produk/varian", className: "bg-red-100 text-red-700" },
  qty_mismatch: { label: "Beda jumlah", className: "bg-red-100 text-red-700" },
  needs_variant_check: { label: "Perlu cek varian", className: "bg-amber-100 text-amber-800" },
  not_available: { label: "Belum dapat diverifikasi", className: "bg-taupe/20 text-cocoa" },
  matched: { label: "Varian sesuai", className: "bg-status-passed/15 text-status-passed" },
};

const detailText = (item) => {
  const attributes = [
    `Warna: ${item.color || "-"}`,
    `Size: ${item.size || "-"}`,
    `Qty: ${item.quantity || 0}`,
    `SKU: ${item.sku || "-"}`,
  ];
  if (item.variation) {
    attributes.unshift(`Variasi file: ${item.variation}`);
  }
  return attributes.join(" · ");
};

const ItemLines = ({ items, testIdPrefix }) => (
  <div className="space-y-2">
    {items.map((item, index) => (
      <div data-testid={`${testIdPrefix}-${index}`} key={`${item.name}-${item.sku}-${index}`}>
        <div className="text-sm font-medium text-cocoa">{item.name}</div>
        <div className="text-xs text-wmuted">{detailText(item)}</div>
      </div>
    ))}
  </div>
);

export const ShippingVariantDetails = ({ idPrefix = "shipping-variant-details", row }) => {
  const marketplaceItems = row.marketplace_product_details || [];
  const sales = row.sales || [];
  const linkedSale = row.linked_flash_sale;
  const diff = row.variant_diff || [];
  const variantStatus = row.variant_check_status;
  const hasCashierItems = sales.some((sale) => sale.item_details?.length) || (
    linkedSale?.item_details?.length
  );

  if (!marketplaceItems.length && !hasCashierItems) {
    return <span className="text-sm text-wmuted">Detail varian belum tersedia</span>;
  }

  const badge = VARIANT_BADGE[variantStatus];

  return (
    <div className="space-y-3" data-testid={`${idPrefix}-${row.id}`}>
      {badge && row.match_status === "matched" && (
        <Badge className={`border-0 ${badge.className}`} data-testid={`${idPrefix}-badge-${row.id}`}>
          {badge.label}
        </Badge>
      )}
      {diff.length > 0 && (
        <div className="overflow-x-auto rounded border border-taupe/30">
          <table className="w-full text-xs" data-testid={`${idPrefix}-diff-${row.id}`}>
            <thead className="bg-taupe/10 text-wmuted">
              <tr>
                <th className="px-2 py-1 text-left font-medium">Produk / Varian</th>
                <th className="px-2 py-1 text-center font-medium">MP</th>
                <th className="px-2 py-1 text-center font-medium">Kasir</th>
                <th className="px-2 py-1 text-center font-medium">Selisih</th>
                <th className="px-2 py-1 text-left font-medium">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {diff.map((line, index) => (
                <tr
                  className="border-t border-taupe/20"
                  data-testid={`${idPrefix}-diff-row-${row.id}-${index}`}
                  key={`${line.label}-${index}`}
                >
                  <td className="px-2 py-1 text-cocoa">{line.label}</td>
                  <td className="px-2 py-1 text-center">{line.marketplace_qty}</td>
                  <td className="px-2 py-1 text-center">{line.cashier_qty}</td>
                  <td className={`px-2 py-1 text-center font-medium ${line.diff === 0 ? "text-wmuted" : "text-status-reject"}`}>
                    {line.diff > 0 ? `+${line.diff}` : line.diff}
                  </td>
                  <td className="px-2 py-1 text-wmuted">{line.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {marketplaceItems.length > 0 && (
        <div className="border-l-2 border-taupe/35 pl-3">
          <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-wmuted">
            Marketplace
          </div>
          <ItemLines
            items={marketplaceItems}
            testIdPrefix={`${idPrefix}-marketplace-${row.id}`}
          />
        </div>
      )}
      {sales.filter((sale) => sale.item_details?.length).map((sale) => (
        <div className="border-l-2 border-cocoa/45 pl-3" key={sale.id}>
          <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-cocoa">
            Kasir · {sale.number}
          </div>
          <ItemLines
            items={sale.item_details}
            testIdPrefix={`${idPrefix}-cashier-${row.id}-${sale.id}`}
          />
        </div>
      ))}
      {linkedSale?.item_details?.length > 0 && (
        <div className="border-l-2 border-cocoa/45 pl-3">
          <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-cocoa">
            Pesanan Kilat · {linkedSale.number}
          </div>
          <ItemLines
            items={linkedSale.item_details}
            testIdPrefix={`${idPrefix}-flash-${row.id}`}
          />
        </div>
      )}
    </div>
  );
};
